import { TweenMax, Power3 } from "gsap";
import Helpers from "../helpers";

export default class Channels {
    constructor(element) {
        this.element = document.querySelector(element);
        if (!element) return;
        this.currentIndex = 0;
        this.slider = null;
        this.channelsInfoWrapperHeight = 0;
        try {
            this.channelsInfoWrapper = this.element.querySelector(
                ".channels__slider-info-wrapper"
            );
        } catch (error) {
            return;
        }

        this.channelsInfoItems = this.channelsInfoWrapper.querySelectorAll(
            ".channels__slider-info"
        );
        this.sliderLinks = this.element.querySelectorAll(".slider__nav-link");
        this.sliderNextButton = document.querySelector(
            ".small-and-big__btn--next"
        );
        this.sliderPrevButton = document.querySelector(
            ".small-and-big__btn--previous"
        );

        this.init();
        this.bindEvents();
    }

    init() {
        this.getMainSliderHeight();
        this.setActiveSlide(true);
    }

    bindEvents() {
        Helpers.forEach(this.sliderLinks, (index, item) => {
            item.addEventListener("click", event => {
                event.preventDefault();
                let el = event.currentTarget;
                const elementIndex = [...el.parentElement.children].indexOf(el);

                if (this.currentIndex === index) return;
                this.currentIndex = index;

                this.setActiveSlide();
            });
        });
        if (this.sliderNextButton && this.sliderPrevButton) {
            this.sliderNextButton.addEventListener("click", () => {
                let slidesLen = this.channelsInfoItems.length;
                if (this.currentIndex < slidesLen - 1) {
                    let currentItem = this.channelsInfoItems[this.currentIndex];
                    this.currentIndex += 1;

                    let item = this.channelsInfoItems[this.currentIndex];
                    this.sliderLinks.forEach(item => {
                        item.classList.remove("slider__nav-link--active");
                    });
                    this.sliderLinks[this.currentIndex].classList.add(
                        "slider__nav-link--active"
                    );
                    this.animSlideOut(currentItem, 0.7);
                    this.getMainSliderHeight(item);
                    this.animSlideIn(item, 0.7);
                }
            });
            this.sliderPrevButton.addEventListener("click", () => {
                if (!this.currentIndex <= 0) {
                    let currentItem = this.channelsInfoItems[this.currentIndex];
                    this.currentIndex -= 1;
                    let item = this.channelsInfoItems[this.currentIndex];
                    this.sliderLinks.forEach(item => {
                        item.classList.remove("slider__nav-link--active");
                    });
                    this.sliderLinks[this.currentIndex].classList.add(
                        "slider__nav-link--active"
                    );
                    this.animSlideOut(currentItem, 0.7);
                    this.getMainSliderHeight(item);
                    this.animSlideIn(item, 0.7);
                }
            });
        }
    }

    setActiveSlide(force = false) {
        Helpers.forEach(
            this.channelsInfoItems,
            (index, item) => {
                this.getMainSliderHeight();
                if (force) {
                    this.currentIndex === index
                        ? this.animSlideIn(item, 0)
                        : this.animSlideOut(item, 0);
                } else {
                    this.currentIndex === index
                        ? this.animSlideIn(item)
                        : this.animSlideOut(item);
                }
            },
            null
        );

        Helpers.forEach(this.sliderLinks, (index, item) => {
            this.currentIndex === index
                ? item.classList.add("slider__nav-link--active")
                : item.classList.remove("slider__nav-link--active");
        });
    }

    animSlideOut(element, duration = 0.8) {
        TweenMax.to(element, duration, {
            x: -10,
            autoAlpha: 0,
            ease: Power3.easeInOut
        });
    }

    animSlideIn(element, duration = 0.8) {
        TweenMax.set(element, { x: 10 });
        TweenMax.to(element, duration, {
            x: 0,
            autoAlpha: 1,
            ease: Power3.easeInOut
        });
    }

    getMainSliderHeight(item = null) {
        //Scale wrapper to the active item
        if (item) {
            this.channelsInfoWrapperHeight = item.clientHeight;
            TweenMax.to(this.channelsInfoWrapper, 0.34, {
                height: this.channelsInfoWrapperHeight
            });
            return;
        }

        Helpers.forEach(this.channelsInfoItems, (index, item) => {
            if (this.channelsInfoWrapperHeight < item.clientHeight) {
                this.channelsInfoWrapperHeight = item.clientHeight;
            }
        });

        TweenMax.to(this.channelsInfoWrapper, 0.34, {
            height: this.channelsInfoWrapperHeight
        });
    }
}
